import React, { useState } from 'react';
import './leanding.css';

import image1 from '../assets/images/Group 949 (1).png';
import image2 from '../assets/images/image 13.png';
import image4 from '../assets/images/OBJECTS (1).png';
import image5 from '../assets/images/OBJECTS (2).png';
import image6 from '../assets/images/OBJECTS (3).png';
import image7 from '../assets/images/OBJECTS.png';
import image8 from '../assets/images/OBJECTS (4).png';
import Features from '../features/features';
import Whatitohk from '../whatitohk/whatitohk';
import Howitwork from '../howitwork/howitwork';
import Footer from '../footer/footer';
import { Link } from 'react-router-dom';



const LandingPage = () => {
   const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const toggleNav = () => setIsMobileNavOpen(!isMobileNavOpen);
  const closeNav = () => setIsMobileNavOpen(false);
  return (
    <>
    <div className="landingmain">
    <section className="landing-page " id="home">
    <header className="header container">
  <div className="header-top">
    <div className="logoManager">
              <Link to='/' style={{ textDecoration: "none" }}>
      
      <h3 style={{ color: "#fff" }}>
        BI <span>Manager</span>
        
      </h3>
      </Link>
    </div>

    {/* Mobile Toggle Button on the right */}
    <button className="nav-toggle d-md-none" onClick={toggleNav}>
      ☰
    </button>
  </div>

  {/* Navigation Menu */}
  <nav className={`nav ${isMobileNavOpen ? "open" : ""}`}>
    <button className="nav-close d-md-none" onClick={closeNav}>✕</button>
     <ul>
      <li><Link to="/" onClick={closeNav}>Home</Link></li>
      <li><Link to="/about" onClick={closeNav}>About</Link></li>
      <li><Link to="/" onClick={closeNav}>CreateRFQ</Link></li>
      <li><Link to="/" onClick={closeNav}>ForVendors</Link></li>
      <li><Link to="/faqs" onClick={closeNav}>FAQ's</Link></li>
      <li><Link to="/contact" onClick={closeNav}>Contact</Link></li>
      <li>
        <Link to="/login">
          <button className="login-btn">Login</button>
        </Link>
      </li>
    </ul>
  </nav>
</header>


      <div className="hero-content container">
        <div className="text-content">
          <h1>Easily Manage Supplier Quotes in One Place</h1>
          <p>Create, send, and manage RFQs with ease.</p>
          <div className="buttons">
            <button className="btn get-started">
              Get Started

            <button className="btn register ml-5">Register Now</button>
              </button>
          </div>
          <div className="bottom-links">
            <a href="#start-rfq">Start an RFQ →</a>
            <a href="#login-account">Login to your account →</a>
          </div>
        </div>

        <div className="graphics">
          <img src={image1} alt="Vendor Engagement Rate" />
         
        </div>
      </div>
    </section>

    <Features/>
    <Whatitohk/>
    <Howitwork/>
    <Footer/>
    </div>
    </>

  );
};

export default LandingPage;
